export const SALES = 'sales';
export const LISTINGS = 'listings';
export const RENTALS = 'rentals';

export const COMPARABLE_TYPES = {
    [SALES]: SALES,
    [LISTINGS]: LISTINGS,
    [RENTALS]: RENTALS,
};

export const LABELS = {
    [SALES]: 'Sale',
    [LISTINGS]: 'Listing',
    [RENTALS]: 'Rental',
};

// This might seem redundant, but this is the original comparable type mapping used in various parts of the application.
// This was just moved here to remove circular dependencies.
// Replacing its usage with COMPARABLE_TYPES is a future task.
export const COMPARABLE_TYPE = {
    LISTINGS: 'listings',
    SALES: 'sales',
    RENTALS: 'rentals',
};